angular.module('tcApp')
.service('PathwayService', function($window, TimelineService, OverlayService) {
	var d3 = $window.window.d3;
	var svgNS = 'http://www.w3.org/2000/svg';
	var dimensions = {
		barThickness: 10,
		selectionBorderThickness: 3, // thickness of border around popover selection
		ellipseRx: 15,
		ellipseRy: 10,
		borderWidth: 2
	};
	var getPathwayItemsByTimeRange = function(items, startTime, endTime) {
		var itemsInRange = items.filter(function(item) {
			return (startTime <= item.time) && (item.time < endTime);
		});
		return itemsInRange;
	};

	var createIndicator = function(d) {
		var element = d3.select($window.document.createElementNS(svgNS, 'g'));
		element.append('ellipse') // White border 
			.classed('pathwayIndicatorOutline pathwayIndicatorBasic', true)
			.attr('rx', dimensions.ellipseRx + dimensions.borderWidth) 
			.attr('ry', dimensions.ellipseRy + dimensions.borderWidth);
		element.append('ellipse') // Indicator Ellipse
			.classed(d.statusClass + ' pathwayIndicatorBasic', true)
			.attr('rx', dimensions.ellipseRx) 
			.attr('ry', dimensions.ellipseRy); 
		element.append('text') // Number of pathway items
			.text(d.nbItems)
			.classed(d.statusTextClass  + ' pathwayIndicatorTextBasic', true);
		element.attr('class', 'indicator');
		return element.node();
	};
				
	var drawIndicator = function(ctrl, itemGroup, data, yPosition) { 
		var markers = itemGroup
			.selectAll('.indicator') 
			.data(data, function(d) { return d.time;});
		markers.enter()
			.append(function(d) {return createIndicator(d);})
			.merge(markers)
			.attr('transform',  function(d) {
			return 'translate(' + ctrl.getXCoordinateFromTime(d.time) + ', ' + yPosition + ')';
		});
		markers.exit().remove();
	};
	
	var getIndicatorTime =  function(itemStartTime, itemEndTime, startInterval, endInterval) {
		var indicatorTime = (startInterval + endInterval) / 2;
		if (startInterval <= itemStartTime && itemEndTime < endInterval) {
			// The entire pathway is within the interval range
			indicatorTime = (itemStartTime + itemEndTime) / 2;
		} else {
			// Place the indicator at the extremity of the pathway
			if (indicatorTime < itemStartTime) {
				indicatorTime = itemStartTime;
			} else if (itemEndTime < indicatorTime) {
				indicatorTime = itemEndTime;
			}
		}
		return indicatorTime;
	};
	
	var getGraphTimes = function(itemStartTime, itemEndTime, $scope) {
		var tFrom = Math.max($scope.tcTimeFrom, itemStartTime);    // Earliest displayed date
		var tTo = Math.min($scope.tcTimeTo, itemEndTime);          // Latest displayed date
		var selectionTimes = TimelineService.getColumnTimes(tFrom,  $scope.tcTimeInterval);
		tFrom = selectionTimes[0];  // Hidden start of the first interval 
		selectionTimes = TimelineService.getColumnTimes(tTo,  $scope.tcTimeInterval);
		tTo = selectionTimes[1];    // Hidden end of the last interval
		return [tFrom, tTo];
	};
	
	var getIndicatorsToDraw = function(tFrom, tTo, item, $scope) {
		var indicatorTimes = [];
		while (tFrom < tTo) {
			var selectionTimes = TimelineService.getColumnTimes(tFrom,  $scope.tcTimeInterval);     
			var intervalSize = selectionTimes[1] - selectionTimes[0];
			var itemsInRange = getPathwayItemsByTimeRange(item.pathwayItems, tFrom, tFrom + intervalSize);
			if (itemsInRange.length > 0) {
				// Calculate indicator time
				var startInterval = Math.max(tFrom, $scope.tcTimeFrom);
				var endInterval = Math.min(tFrom + intervalSize, $scope.tcTimeTo);
				var indicatorTime = getIndicatorTime(item.startTime, item.endTime, startInterval, endInterval);
				// Calculate pathway item timeline status based on pathway item status
				var indicatorStatus = getIndicatorStatus(itemsInRange);
				var indicatorData =  angular.extend({time: indicatorTime, nbItems: itemsInRange.length}, indicatorStatus);
				indicatorTimes.push(indicatorData);
			}
			tFrom = selectionTimes[1];
		}
		return indicatorTimes; 
	};
	
	var getIndicatorStatus = function(itemsInRange) {
		var countActionedCompleted = 0;
		var countActionedNotCompleted = 0;
		var countReadyAction = 0;
		var countNotReadyAction = 0;
		var countDeleted = 0;
		angular.forEach(itemsInRange, function(element) { 
			switch (element.status) {
				case 'ActionedCompleted': // Grey filled
					countActionedCompleted++;
				break;
				case 'ActionedNotCompleted':
					countActionedNotCompleted++; // Blue filled
				break;
				case 'ReadyAction': // Blue border
					countReadyAction++;
				break;
				case 'NotReadyAction': // Grey border
					countNotReadyAction++;
				break;
				case 'Deleted': // Grey filled
					countDeleted++;
				break;
				default:
			}
		});
		var statusClass = 'pathwayIndicator';
		var statusTextClass = 'pathwayIndicatorText';
		if (countReadyAction > 0) { // 1. ReadyAction - Blue border
			statusClass += 'ReadyAction';
			statusTextClass += 'Dark';
		} else if (countActionedNotCompleted > 0) { // 2. ActionedNotCompleted - Blue filled
			statusClass += 'ActionedNotCompleted';
			statusTextClass += 'Light';
		} else if (countNotReadyAction > 0) { // 3. NotReadyAction - Grey border
			statusClass += 'NotReadyAction';
			statusTextClass += 'Dark';
		} else if (countActionedCompleted > 0) { // 4. ActionedCompleted - Grey filled
			statusClass += 'ActionedCompleted';
			statusTextClass += 'Light';
		} else if (countDeleted > 0) { // 5. Deleted - Grey filled
			statusClass += 'ActionedCompleted'; // Same color as Actioned Completed
			statusTextClass += 'Light';
		} else { // This style class is assigned when the item status is not defined as a timeline status
			statusClass += 'Other';
			statusTextClass += 'Light';
		}
		var indicatorStatus = {statusClass: statusClass,statusTextClass: statusTextClass};
		return indicatorStatus;
	};
	
	this.serviceOnDisplay = function($scope, ctrl, axisGroup) {
		var popoverSelectionXOffset = dimensions.selectionBorderThickness / 2;
		var popoverSelectionYOffset = dimensions.selectionBorderThickness / 2;
		var popoverSelectionY = 1 + popoverSelectionYOffset;
		var scrollableContainer = axisGroup.getDataSvgContainer();
		scrollableContainer.append('rect')
			.classed('popoverSelection', true)
			.attr('id', axisGroup.htmlIdPrefix + '-popoverSelection')
			.attr('y', popoverSelectionY)
			.attr('stroke-width', dimensions.selectionBorderThickness + 'px');

		var popoverHandler = function() {
			var mouseTime = $scope.tcXScale.invert(d3.mouse(scrollableContainer.node())[0]);
			var selectionTimes = TimelineService.getColumnTimes(mouseTime, $scope.tcTimeInterval);
			var selectionStart = ctrl.getXCoordinateFromTime(selectionTimes[0]);
			var selectionEnd = ctrl.getXCoordinateFromTime(selectionTimes[1]);
			var selectedItem = axisGroup.yAxes[0].items[0];

			// Select the pathway if there are pathway items
			var pathwayItemsInRange = getPathwayItemsByTimeRange(selectedItem.pathwayItems, selectionTimes[0],  selectionTimes[1]);
			if (pathwayItemsInRange.length === 0) return;

			// Popover rectangle around the selected interval
			var popoverSelection = scrollableContainer.select('rect.popoverSelection')
				.attr('x', selectionStart + popoverSelectionXOffset)
				.attr('width', selectionEnd - selectionStart - 2 * popoverSelectionXOffset)
				.attr('height', $scope.viewModel.axisGroupModel[axisGroup.index].dimensions.height
								- popoverSelectionY - popoverSelectionYOffset)
				.style('opacity', 1);
			scrollableContainer.node().appendChild(popoverSelection.node()); // brings popoverSelection to front

			var ItemsDataJSON = encodeURIComponent(angular.toJson(pathwayItemsInRange)); // Encode URI before passing it to popoverParams
			var popoverParams = axisGroup.popoverParams + '&ItemsData=' + ItemsDataJSON;

			$scope.$emit('Timeline:pauseAutoRefresh', {reason: 'Popover'});

			var overlayOptions = {
				event: d3.event,
				componentName: 'system.Timeline.PathwayTimeline.Popover', 
				params: popoverParams,
				popoverFor: popoverSelection.attr('id'),
				onRemovingHandler: function() {
					popoverSelection.style('opacity', 0);
					$scope.$emit('Timeline:playAutoRefresh', {reason: 'Popover'});
				}
			};
			OverlayService.open(overlayOptions);
		};
		axisGroup.getMainGraphSvg().on('click', popoverHandler);
	}; 
	
	this.getStyleAxisTicks = function() {
		var styleAxisTicks = function(g) {
			g.selectAll('.tick text').text(''); 
		};
		
		return styleAxisTicks;
	};
							
	this.getDrawAxisItemData = function($scope, ctrl, axisGroup) {		
		var drawAxisItemData = function(axis, axisSVGGroup, item, itemGroup, transition) {
			var start = ctrl.getXCoordinateFromTime(item.startTime);
			var end = ctrl.getXCoordinateFromTime((item.endTime === '') ? $scope.tcTimeNow : item.endTime);
			var height = ctrl.getYCoordinateFromValue(item.value, axisGroup.index, 0);
			var thickness = dimensions.barThickness;
			var width = end - start;
			var fillInterval = 'pathwayIndicatorActionedNotCompleted';

			var points = '';
			var eventElement = TimelineService.getOrCreateSvgElementByType('polygon', itemGroup);
			if (item.type == 'Pathway') {
				// This is a Pathway Timeline
				if (item.status == 'onGoing' || item.status == 'ended') {
					// Draw a rectangle 
					if (item.status == 'ended') {
						fillInterval = 'pathwayIndicatorActionedCompleted';
					} 
					points = '0,' + -thickness / 2 + ' '
							+ width + ',' + -thickness / 2 + ' '
							+ width + ',' + thickness / 2 + ' '
							+ '0,' + thickness / 2;
					eventElement.attr('points', points)
								.attr('transform', 'translate(' + start + ', ' + height + ')')
								.classed(fillInterval , true)
								.transition(transition);

					// Graph Time Range
					var graphTimes = getGraphTimes(item.startTime, item.endTime, $scope);
					var tFrom = graphTimes[0];
					var tTo = graphTimes[1];
					// Find the pathway items in each interval and plot the indicators/markers
					var indicatorTimes = getIndicatorsToDraw(tFrom, tTo, item, $scope);
					// Draw Indicator Text and Ellipse Markers
					drawIndicator(ctrl, itemGroup, indicatorTimes, height);
									
				} else if (item.status == 'noDates') {
					// Pathway has no start and end date 
					points =  -thickness / 2 + ',' + -thickness / 2 + ' '
							+ -thickness / 2 + ',' +  thickness / 2 + ' '
							+  thickness / 2 + ',' +  thickness / 2 + ' '
							+  thickness / 2 + ',' + -thickness / 2;
					
					eventElement.attr('points', points) 
								.classed(fillInterval , true)
								.attr('transform', 'translate(' + start + ', ' + height + ')');
				} 

			}
		};
		return drawAxisItemData;
	};
});

